module.exports = __webpack_public_path__ + "static/media/ico_download.1be7bb84.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/Drawing/imgs/ico_download.svg
// module id = 1678
// module chunks = 0